<template>
    <v-col cols="12" xl="10" class="py-10 px-0">
        <v-row>
            <v-col cols="12">
                <v-fade-transition>
                    <v-row v-if="role && !role.active">
                        <v-col cols="12">
                            <b-alert type="error" :message="t('roles::status.deactivation.info')"> </b-alert>
                        </v-col>
                    </v-row>
                </v-fade-transition>
            </v-col>
            <v-col cols="12" lg="4" class="py-0">
                <b-input
                    to-mutate="dms_roles::dms_role.name"
                    :label="t('roles::create.name')"
                    :rules="validationRules.name"
                    :disabled="readOnlyRules"
                    mandatory
                ></b-input>
            </v-col>
            <v-col cols="12" lg="4" class="py-0">
                <b-select
                    to-mutate="dms_roles::dms_role.group"
                    :label="t('roles::create.group')"
                    :rules="validationRules.group"
                    :select-items="roleGroups"
                    :disabled="readOnlyRules"
                    mandatory
                ></b-select>
            </v-col>
            <v-col cols="12" lg="4" class="py-0">
                <b-switch
                    to-mutate="dms_roles::dms_role.active"
                    :label="t('roles::create.active')"
                    :disabled="readOnlyRules"
                ></b-switch>
            </v-col>
            <v-col cols="12" lg="8" class="py-0 pb-4">
                <b-textarea
                    to-mutate="dms_roles::dms_role.description"
                    :label="t('roles::create.description')"
                    :disabled="readOnlyRules"
                ></b-textarea>
            </v-col>
        </v-row>
    </v-col>
</template>

<script>
export default {
    data() {
        return {
            roleGroups: [
                { text: t('roles::group.admins'), value: 'admins' },
                { text: t('roles::group.hcps'), value: 'hcps' },
                { text: t('roles::group.devices'), value: 'devices' },
            ],
            validationRules: {
                name: [(v) => !!v || t('users::validation.field.required')],
                group: [(v) => !!v || t('users::validation.field.required')],
            },
        };
    },
    computed: {
        role() {
            return this.$store.state.dms_roles.dms_role;
        },
        readOnlyRules() {
            return !this.can('api.v1.roles.update') || this.role.readonly;
        },
    },
};
</script>
